import React from 'react';

const SingleMember = ({ image, name }) => {
  return (
    <div className="checkbox-container">
      <img src={image} alt="avatar" className="team-avater" />
      <p className="label">{name}</p>
    </div>
  );
};

export default SingleMember;
